import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import "./payment-handler.css";
import Lottie from 'lottie-react';
import { toast } from "react-toastify";
import animate1 from '../../utils/order_placed_back_animation.json';
import animate2 from '../../utils/order_success_tick_animation.json';
import NoOrderSVG from "../../utils/zero-state-screens/No_Orders.svg";
import api from '../../api/api';
import { setCart, setCartCheckout, setCartProducts, setCartSubTotal, setHDFCOrderID, setHDFCWalletOrderID, setIsHDFCWalletPayment } from '../../model/reducer/cartReducer';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../loader/Loader';

const PayPalPaymentHandler = () => {

    const location = useLocation();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const user = useSelector(state => state?.user);
    const hdfcOrderID = useSelector(state => state?.cart?.hdfcOrderID);
    const isHDFCWalletPayment = useSelector(state => state?.cart?.isHDFCWalletPayment);
    const hdfcWalletOrderID = useSelector(state => state?.cart?.hdfcWalletOrderID);
    const queryParams = new URLSearchParams(location.search);
    const queryParamsObj = {};
    for (const [key, value] of queryParams.entries()) {
        queryParamsObj[key] = value;
    }
    const [isOrderPayment, setIsOrderPayment] = useState(false);
    const [timer, setTimer] = useState(20);
    const [isLoading, setIsLoading] = useState(false);
    const interval = useRef();
    const timeout = useRef();
    // https://devegrocer.thewrteam.in/web-payment-status?status=&type=order&payment_method=Paytabs&order_id=2429

    useEffect(() => {
        let intervalId;
        if (queryParamsObj.type == "wallet") {
            if (queryParamsObj.status == "failed") {
                toast.error("Payment failed");
            } else if (queryParamsObj.status == "PAYMENT_SUCCESS" || queryParamsObj.status == "success" || queryParamsObj.status_code == 200) {
                intervalId = setInterval(() => {
                    window.opener.postMessage("Recharge Done", "*");
                }, 1000);
            } else if (queryParamsObj.status == "") {
                toast.error("Something went wrong");
            }
        } else {
            const orderId = queryParamsObj?.payment_method == "Paytabs" ? queryParamsObj?.order_id : queryParamsObj?.order_id?.split("-")[1]
            if (queryParamsObj.status == "failed") {
                toast.error("Payment failed");
                api.deleteOrder(user?.jwtToken, orderId).then((res) => (res.json()).then((result) => {
                })).catch((err) => {
                    console.log("Error", err)
                })
            } else if (queryParamsObj.status == "") {
                api.deleteOrder(user?.jwtToken, orderId).then((res) => (res.json()).then((result) => {
                })).catch((err) => {
                    console.log("Error", err)
                })
                toast.error("Something went wrong");
            } else if (queryParamsObj.status_code = 201 && queryParamsObj.action == "back") {
                toast.error("payment cancelled");
                api.deleteOrder(user?.jwtToken, orderId).then((res) => (res.json()).then((result) => {

                })).catch((err) => {
                    console.log("Error", err)
                })
            }
            // else if (queryParams.size === 0 && hdfcOrderID === null && isHDFCWalletPayment === false) {
            //     setIsOrderPayment(true);
            //     try {
            //         api.removeCart(user?.jwtToken).then((res) => res.json()).then((result) => {
            //             if (result?.status === 1) {
            //                 dispatch(setCart({ data: null }));
            //                 dispatch(setCartCheckout({ data: null }));
            //                 dispatch(setCartProducts({ data: [] }));
            //                 dispatch(setCartSubTotal({ data: 0 }));
            //             } else if (result?.status === 0 && result?.message === "no_items_found_in_users_cart") {
            //                 setIsOrderPayment(true);
            //                 toast.error(t("no_items_found_in_users_cart"));
            //             }
            //         });
            //     } catch (err) {
            //         console.log(err.message);
            //     }
            // }
        }
        if (hdfcOrderID === null && isHDFCWalletPayment === false) {
            interval.current = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
            timeout.current = setTimeout(() => {
                setIsOrderPayment(false);
                navigate("/");
            }, 15000);
        }
        return () => {
            clearInterval(interval.current);
            clearTimeout(timeout);
            clearInterval(intervalId);
        };
        // if (queryParamsObj.status == "PAYMENT_SUCCESS" && queryParamsObj.type == "wallet" && queryParamsObj.payment_method == "Phonepe") {
        //     intervalId = setInterval(() => {
        //         window.opener.postMessage("Recharge Done", "*");
        //     }, 1000);
        // }
        // else if (queryParamsObj.status == "" && queryParamsObj.type == "wallet" && queryParamsObj.payment_method == "Paytabs") {
        //     toast.error("Something went wrong");
        // }
        // else if (queryParamsObj.status == "failed" && queryParamsObj.type == "wallet" && queryParamsObj.payment_method == "Paytabs") {
        //     toast.error("Payment failed");
        // }
        // else if (queryParamsObj.status_code == 200 && queryParamsObj.order_id.split("-")[0] == "wallet") {
        //     intervalId = setInterval(() => {
        //         window.opener.postMessage("Recharge Done", "*");
        //     }, 1000);
        // }
        // else if (queryParamsObj.payment_method == "Cashfree" && queryParamsObj.status == "success" && queryParamsObj.type == "wallet") {
        //     toast.success("Recharge Done");
        // }
        // else if (queryParamsObj.payment_method == "Cashfree" && queryParamsObj.status == "failed" && queryParamsObj.type == "wallet") {
        //     toast.error("Recharge Fail");
        // }
        // else if (queryParamsObj.type === "wallet") {
        //     toast.success(t("wallet_recharge_paypal_pending_message"));
        // }
        // else if (queryParamsObj.payment_method == "Cashfree" && queryParamsObj.status == "failed" && queryParamsObj.type == "order") {
        //     toast.error("Recharge Fail");
        // }
        // else if (queryParamsObj.payment_method == "Cashfree" && queryParamsObj.status == "" && queryParamsObj.type == "order") {
        //     toast.error("Order cancelled")
        // }
        // else if (queryParamsObj.payment_method == "Paytabs" && queryParamsObj.status == "" && queryParamsObj.type == "order") {
        //     toast.error("Order cancelled")
        // }
        // else if (queryParamsObj.status == "failed" && queryParamsObj.type == "order" && queryParamsObj.payment_method == "Paytabs") {
        //     toast.error("Order failed")
        // }
        // else {
        //     setIsOrderPayment(true);
        //     try {
        //         api.removeCart(user?.jwtToken).then((res) => res.json()).then((result) => {
        //             if (result?.status === 1) {
        //                 dispatch(setCart({ data: null }));
        //                 dispatch(setCartCheckout({ data: null }));
        //                 dispatch(setCartProducts({ data: [] }));
        //                 dispatch(setCartSubTotal({ data: 0 }));
        //             }
        //         });
        //     } catch (err) {
        //         console.log(err.message);
        //     }
        // }
        // interval.current = setInterval(() => {
        //     setTimer(prev => prev - 1);
        // }, 1000);
        // timeout.current = setTimeout(() => {
        //     setIsOrderPayment(false);
        //     navigate("/");
        // }, 6000);
        // return () => {
        //     clearInterval(interval.current);
        //     clearTimeout(timeout);
        //     clearInterval(intervalId);
        // };
    }, []);
    const handleNavigate = () => {
        navigate("/");
    };

    const checkHDFCPaymentStatus = async () => {
        if (hdfcOrderID && !isHDFCWalletPayment) {
            const response = await api.checkHDFCPaymentStatus(user?.jwtToken, hdfcOrderID);
            const data = await response.json();
            if (data?.data?.status === "success" && data?.data?.message === "CHARGED") {
                setIsOrderPayment(true);
                setIsLoading(false);
                clearInterval(interval.current);
                clearTimeout(timeout.current);
                try {
                    api.removeCart(user?.jwtToken).then((res) => res.json()).then((result) => {
                        if (result?.status === 1) {
                            dispatch(setCart({ data: null }));
                            dispatch(setCartCheckout({ data: null }));
                            dispatch(setCartProducts({ data: [] }));
                            dispatch(setCartSubTotal({ data: 0 }));
                        }
                    });
                } catch (err) {
                    console.log(err.message);
                }
            }
            //  else if (data?.data?.status === "pending" && timer === 1) {
            //     try {
            //         api.removeCart(user?.jwtToken).then((res) => res.json()).then((result) => {
            //             if (result?.status === 1) {
            //                 dispatch(setCart({ data: null }));
            //                 dispatch(setCartCheckout({ data: null }));
            //                 dispatch(setCartProducts({ data: [] }));
            //                 dispatch(setCartSubTotal({ data: 0 }));
            //             } else if (result?.status === 0 && result?.message === "no_items_found_in_users_cart") {
            //                 setIsOrderPayment(true);
            //                 toast.error(t("no_items_found_in_users_cart"));
            //             }
            //         });
            //     } catch (error) {
            //         console.error("Error deleting the hdfc failed order", error);
            //     }
            // }
        } else if (isHDFCWalletPayment) {
            const response = await api.checkHDFCPaymentStatus(user?.jwtToken, hdfcWalletOrderID);
            const data = await response.json();
            if (data?.data?.status === "success") {
                setIsLoading(false);
                clearInterval(interval.current);
                clearTimeout(timeout.current);
            }
        }
    }

    useEffect(() => {
        if (hdfcOrderID) {
            // console.log("HDFC order id found, checking payment status...");
            setIsLoading(true);
            interval.current = setInterval(() => {
                checkHDFCPaymentStatus();
            }, 1500);
            timeout.current = setTimeout(() => {
                setIsOrderPayment(false);
                toast.info(t("payment_processing"))
                try {
                    api.removeCart(user?.jwtToken).then((res) => res.json()).then((result) => {
                        if (result?.status === 1) {
                            dispatch(setCart({ data: null }));
                            dispatch(setCartCheckout({ data: null }));
                            dispatch(setCartProducts({ data: [] }));
                            dispatch(setCartSubTotal({ data: 0 }));
                            dispatch(setHDFCOrderID({ data: null }));
                            navigate("/");
                        } else if (result?.status === 0 && result?.message === "no_items_found_in_users_cart") {
                            // setIsOrderPayment(true);
                            dispatch(setHDFCOrderID({ data: null }));
                            toast.error(t("no_items_found_in_users_cart"));
                            navigate("/");
                        }
                    });
                } catch (error) {
                    console.error("Error deleting the hdfc failed order", error);
                    dispatch(setHDFCOrderID({ data: null }));
                    navigate("/");
                }
            }, 15000);

        } else if (isHDFCWalletPayment) {
            setIsLoading(true);
            interval.current = setInterval(() => {
                checkHDFCPaymentStatus();
            }, 1500);
            timeout.current = setTimeout(() => {
                setIsOrderPayment(false);
                toast.info(t("payment_processing"))
                dispatch(setHDFCWalletOrderID({ data: null }));
                dispatch(setIsHDFCWalletPayment({ data: false }));
                navigate("/");
            }, 10000);
        }
        return () => {
            clearInterval(interval.current);
            clearTimeout(timeout.current);
        };
    }, [hdfcOrderID, isHDFCWalletPayment]);

    if (queryParams.size === 0 && hdfcOrderID) {
        return isLoading ?
            <div className='container d-flex flex-column align-items-center mt-5 payment-container' >
                <Loader background="transparent" width="100px" height="100px" />
                <div className='text-center'>
                    <p className='order-success-desc'>{t("checking_payment_status")}</p>
                </div>
            </div>
            : <div className='container d-flex flex-column align-items-center mt-5 payment-container' >
                <Lottie animationData={animate2} loop={false} className='lottie-tick'></Lottie>
                <Lottie className='lottie-content' animationData={animate1} loop={true}></Lottie>
                <div className='text-center'>
                    <p className='order-success-desc'>{t("order_placed_description")}</p>
                </div>
                <button onClick={handleNavigate} className='checkout_btn'>
                    {t("go_to_home")}
                </button>
            </div>
    }
    if (queryParams.size === 0 && isHDFCWalletPayment) {
        return isLoading ?
            <div className='container d-flex flex-column align-items-center mt-5 payment-container' >
                <Loader background="transparent" width="100px" height="100px" />
                <div className='text-center'>
                    <p className='order-success-desc'>{t("checking_payment_status")}</p>
                </div>
            </div> :
            <div className='container d-flex flex-column align-items-center mt-5 payment-container' >
                <Lottie animationData={animate2} loop={false} className='lottie-tick'></Lottie>
                <Lottie className='lottie-content' animationData={animate1} loop={true}></Lottie>
                <div className='text-center'>
                    <p className='order-success-desc'>{t("wallet_recharge_successfull")}</p>
                </div>
                <button onClick={handleNavigate} className='checkout_btn'>
                    {t("go_to_home")}
                </button>
            </div>

    }

    if (queryParams.size === 0) {
        return (
            <div className='container d-flex flex-column align-items-center mt-5 payment-container'>
                <img src={NoOrderSVG} alt="noOrderSVG" />
            </div>
        );
    }



    return (
        <>
            {isOrderPayment ?
                <div className='container d-flex flex-column align-items-center mt-5 payment-container' >
                    <Lottie animationData={animate2} loop={false} className='lottie-tick'></Lottie>
                    <Lottie className='lottie-content' animationData={animate1} loop={true}></Lottie>
                    <div className='text-center'>
                        <p className='order-success-desc'>{t("order_placed_description")}</p>
                    </div>
                    <button onClick={handleNavigate} className='checkout_btn'>
                        {t("go_to_home")}
                    </button>
                </div>
                : isLoading ?
                    <div className='container d-flex flex-column align-items-center mt-5 payment-container' >
                        <Loader background="transparent" width="100px" height="100px" />
                        <div className='text-center'>
                            <p className='order-success-desc'>{t("checking_payment_status")}</p>
                        </div>
                    </div>
                    : null}
        </>
    );
};

export default PayPalPaymentHandler;